import { Object3D, Vector2, Vector3 } from 'three';
import { BUTTON_HOVER_COLOR, BUTTON_HOVER_TEXT_COLOR, BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, PRIMARY_TEXT_COLOR, TASK_PROGRESS_BACKGROUND_COLOR, WINDOW_HEADER_TEXT_BACKGROUND_COLOR } from '../styleConfig';
import { FuturisticWindow } from './FuturisticWindow';
import { ActionControllerEventName, ButtonComponent, TextComponent, Tween, RoundedPlane, ViewerModule, WindowComponent } from '@verybigthings/vbt-webvr-framework';
export default class LobbyScreen extends ViewerModule {
    constructor() {
        super();
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(20, 13.7),
            radius: 0.6,
            type: 1,
            hasSideImage: true
        }));
        this.addObject(this.header = new TextComponent({
            size: new Vector2(1.1 * 3, 1.1 * 3),
            pxSize: new Vector2(64 * 3, 64 * 3).multiplyScalar(window['quality'] === 'very low' ? 0.7 : 1),
            text: {
                style: { family: 'Nunito', weight: '900', color: 'white', size: `${96 * (window['quality'] === 'very low' ? 0.7 : 1)}px` },
                value: '',
                lineHeight: 96 * (window['quality'] === 'very low' ? 0.7 : 1),
                autoWrappingHorizontal: true,
                margin: { bottom: 18 }
            },
            background: { color: WINDOW_HEADER_TEXT_BACKGROUND_COLOR.getStyle() }
        }));
        this.header.uiObject.position.z = 0.01;
        this.header.uiObject.position.y = 5.25;
        this.addObject(this.text = new TextComponent({
            size: new Vector2(20, 8),
            pxSize: new Vector2(82 * 10, 82 * 4).multiplyScalar(window['quality'] === 'very low' ? 0.7 : 1),
            text: {
                style: { family: 'Nunito', weight: '800', color: PRIMARY_TEXT_COLOR.getStyle(), size: `${49 * (window['quality'] === 'very low' ? 0.7 : 1)}px` },
                value: '',
                autoWrappingHorizontal: false,
                lineHeight: 57.5 * (window['quality'] === 'very low' ? 0.7 : 1),
                align: 'center',
                autoWrapping: true,
                margin: { bottom: 22, top: 5 }
            },
            background: { color: 'transparent' }
        }));
        this.text.uiObject.position.z = 0.01;
        this.text.uiObject.position.y = 0.45;
        this.button = new ButtonComponent({
            type: 'flat',
            size: new Vector3(2 * 2.3 / 1.1, 4 * .7 / 1.15 / 1.1, 1),
            sizePx: new Vector2(128 * 2.3 / 1.06, 256 * .7 / 1.15 / 1.06),
            bordRadius: 0.3,
            background: { radius: 4, color: 'white' },
            text: {
                value: 'Watch Tutorial'.toUpperCase(),
                lineHeight: 40,
                autoWrapping: false,
                autoWrappingHorizontal: false,
                style: { size: '64px', color: BUTTON_PRIMARY_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 60, right: 80, bottom: 25, left: 80 },
            }
        });
        const backWindow = new WindowComponent({
            size: new Vector2(2 * 3.9, 4 * .37),
            bordRadius: 0.3,
            background: 0xff0055,
            bordWidth: 0.12,
            bordColor: BUTTON_PRIMARY_COLOR.getHex()
        });
        backWindow.uiObject.position.z = 0.01;
        this.button.addObject(backWindow);
        this.button.on(ActionControllerEventName.click, () => this.fire('tutorial'));
        this.actionController.on(ActionControllerEventName.over, this.button.uiObject, () => this.buttonHover(this.button, true));
        this.actionController.on(ActionControllerEventName.out, this.button.uiObject, () => this.buttonHover(this.button, false));
        this.addObject(this.secondButton = new ButtonComponent({
            type: 'flat',
            size: new Vector3(2 * 2.3, 4 * .7 / 1.15, 1),
            sizePx: new Vector2(128 * 2.3, 256 * .7 / 1.15),
            bordRadius: 0.3,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start'.toUpperCase(),
                lineHeight: 40,
                style: { size: '64px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                autoWrapping: false,
                autoWrappingHorizontal: false,
                margin: { top: 60, right: 220, bottom: 25, left: 220 },
            }
        }));
        this.secondButton.on(ActionControllerEventName.click, () => this.fire('start'));
        this.actionController.on(ActionControllerEventName.over, this.secondButton.uiObject, () => this.buttonHover(this.secondButton, true));
        this.actionController.on(ActionControllerEventName.out, this.secondButton.uiObject, () => this.buttonHover(this.secondButton, false));
        this.buttonsWrapper = new Object3D();
        this.buttonsWrapper.position.z = 0.01;
        this.buttonsWrapper.position.y = -2.9;
        this.buttonsWrapper.add(this.button.uiObject, this.secondButton.uiObject);
        // this.buttonsWrapper.add(this.button.uiObject, this.secondButton.uiObject);
        this.addObject(this.buttonsWrapper);
        ViewerModule.adjustObjects(this.buttonsWrapper.children, true, 0.75);
        // this.secondButton.uiObject.position.x = 0;
        this.addObject(this.progress = new TextComponent({
            size: new Vector2(20, 8),
            pxSize: new Vector2(82 * 10, 82 * 4).multiplyScalar(window['quality'] === 'very low' ? 0.7 : 1),
            text: {
                style: { family: 'Nunito', weight: '600', color: BUTTON_PRIMARY_COLOR.getStyle(), size: `${40 * (window['quality'] === 'very low' ? 0.7 : 1)}px` },
                value: 'Tasks Remaining 0/0',
                autoWrappingHorizontal: true,
                lineHeight: 40 * (window['quality'] === 'very low' ? 0.7 : 1),
                align: 'center',
                autoWrapping: true,
                margin: { bottom: 13, top: 9 }
            },
            background: { color: 'transparent' }
        }));
        this.progress.uiObject.position.z = 0.01;
        this.progress.uiObject.position.y = -6;
        let progressBackground = RoundedPlane.getRoundedPlane({
            width: 19.95,
            height: 1.7,
            color: TASK_PROGRESS_BACKGROUND_COLOR.getHex(),
            r1: 0,
            r2: 0,
            r3: 0.6,
            r4: 0.6
        });
        progressBackground.position.z = -0.005;
        this.progress.addObject(progressBackground);
    }
    init(headerText, mainText, tasks = '0/0') {
        this.background.init();
        this.header.setText(headerText);
        this.text.setText(mainText);
        this.progress.setText('Tasks Remaining ' + tasks);
        this.uiObject.add(this.buttonsWrapper);
    }
    buttonHover(button = undefined, isActive = true, duration = 200, onUpdate) {
        const oldScale = button.uiObject.scale.clone();
        const newScale = isActive ? new Vector3(1.1, 1.1, 1.1) : new Vector3(1, 1, 1);
        const oldBackColor = isActive ? BUTTON_PRIMARY_COLOR.getStyle() : BUTTON_HOVER_COLOR.getStyle();
        const newBackColor = isActive ? BUTTON_HOVER_COLOR.getStyle() : BUTTON_PRIMARY_COLOR.getStyle();
        const oldTextColor = isActive ? BUTTON_PRIMARY_TEXT_COLOR.getStyle() : BUTTON_HOVER_TEXT_COLOR.getStyle();
        const newTextColor = isActive ? BUTTON_HOVER_TEXT_COLOR.getStyle() : BUTTON_PRIMARY_TEXT_COLOR.getStyle();
        return new Promise((resolve, reject) => {
            if (button !== undefined) {
                button.uiObject.userData.cordTween && button.uiObject.userData.cordTween.stop();
                button.uiObject.userData.cordTween = new Tween({ alpha: 0 }).to({ alpha: 1 }, duration)
                    .onUpdate((alpha) => {
                    const currScale = oldScale.clone().lerp(newScale, alpha);
                    button.uiObject.scale.copy(currScale);
                    // const currBackColor = new Color(oldBackColor).lerp(new Color(newBackColor), alpha);
                    // button.options.background.color = currBackColor.getStyle();
                    //
                    // const currTextColor = new Color(oldTextColor).lerp(new Color(newTextColor), alpha);
                    // button.options.text.style.color = currTextColor.getStyle();
                    //
                    // button.updateElement(button.options);
                })
                    .onComplete(() => {
                    resolve(button);
                })
                    .start();
            }
        });
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
    setProgress(newProgress) {
        this.progress.setText('Tasks Remaining ' + newProgress);
    }
}
